import { defineMessages } from "react-intl";

export const messages = defineMessages({
  "auth.unauthorized.title": {
    id: "auth.unauthorized.title",
    defaultMessage: "Welcome to TopLeader",
  },
  "auth.unauthorized.perex": {
    id: "auth.unauthorized.perex",
    defaultMessage: "Please enter your details",
  },
  "auth.login.email.label": {
    id: "auth.login.email.label",
    defaultMessage: "Email",
  },
  "auth.login.password.label": {
    id: "auth.login.password.label",
    defaultMessage: "Password",
  },
  "auth.login.password-confirm.label": {
    id: "auth.login.password-confirm.label",
    defaultMessage: "Confirm password",
  },
  "auth.login.validation.invalid-credentials": {
    id: "auth.login.validation.invalid-credentials",
    defaultMessage: "Invalid credentials",
  },
  "auth.login.forgot": {
    id: "auth.login.forgot",
    defaultMessage: "Forgot password",
  },
  "auth.login.login": {
    id: "auth.login.login",
    defaultMessage: "Log In",
  },
  "auth.login.google": {
    id: "auth.login.google",
    defaultMessage: "Sign in with Google",
  },
  "auth.login.microsoft": {
    id: "auth.login.microsoft",
    defaultMessage: "Sign in with Microsoft",
  },
  "auth.set-password.perex": {
    id: "auth.set-password.perex",
    defaultMessage:
      "You’ve been invited to join TopLeader. Please set a password to complete the registration",
  },
  "auth.forgot-pass.title": {
    id: "auth.forgot-pass.title",
    defaultMessage: "Forgot password",
  },
  "auth.forgot-pass.perex": {
    id: "auth.forgot-pass.perex",
    defaultMessage:
      "Enter your email and we will send you instructions on how to reset your password",
  },
  "auth.forgot-pass.username.label": {
    id: "auth.forgot-pass.username.label",
    defaultMessage: "Email",
  },
  "auth.forgot-pass.submit": {
    id: "auth.forgot-pass.submit",
    defaultMessage: "Continue",
  },
  "auth.forgot-pass.back": {
    id: "auth.forgot-pass.back",
    defaultMessage: "Back to login",
  },
  "auth.check-email.title": {
    id: "auth.check-email.title",
    defaultMessage: "Check your email",
  },
  "auth.check-email.perex": {
    id: "auth.check-email.perex",
    defaultMessage: "We’ve sent the instructions on",
  },
  "auth.check-email.resend.text": {
    id: "auth.check-email.resend.text",
    defaultMessage: "Didn’t receive the email?",
  },
  "auth.check-email.resend.action": {
    id: "auth.check-email.resend.action",
    defaultMessage: "Send again",
  },
  "auth.password-changed.title": {
    id: "auth.password-changed.title",
    defaultMessage: "Password changed",
  },
  "auth.password-changed.perex": {
    id: "auth.password-changed.perex",
    defaultMessage: "Your password has now been successfully changed",
  },
  "auth.password-changed.login": {
    id: "auth.password-changed.login",
    defaultMessage: "Log In",
  },
  "auth.reset-password.title": {
    id: "auth.reset-password.title",
    defaultMessage: "Set a new password",
  },
  "auth.reset-password.perex": {
    id: "auth.reset-password.perex",
    defaultMessage: "Enter your new password below",
  },
  "auth.reset-password.submit": {
    id: "auth.reset-password.submit",
    defaultMessage: "Change password",
  },
  "auth.set-password.submit": {
    id: "auth.set-password.submit",
    defaultMessage: "Set password",
  },
});
